import React from 'react';
/* import { useLanguage } from '../../../../../store/languageContext';
import { LanguageFactory } from '../../../../../factories'; */
import { Tabs, Card, Row, Col, Button } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import ReadOnlyTextarea from '../../../../CSIComponents/ReadOnlyTextarea';
import DetailItem from '../../../../CSIComponents/DetailItem';

const { TabPane } = Tabs;
interface propsTypes {
    petsDetails: any,
    isEditable: void | any
    changeTab: void | any
}

const PetsDetail = (props: propsTypes) => {
/*     const { language, setLanguage } = useLanguage()
    const lang = new LanguageFactory(language) */
    const data = props.petsDetails
    const toggleToEdit = () => {
        props.isEditable();
        props.changeTab('PetsEdit')
    }
    const detailData = [
        { label: 'Policy Name', value: data.name, span: 6 },
        { label: 'Type', value: data.type, span: 6 },
        { label: 'Size', value: data.size, span: 6 },
        { span: 5 },
        { label: 'Unit of Measure', value: data.uom, span: 6 },
        { label: 'Maximum Number of Pets', value: data.max, span: 6 },
        { label: 'Refundable Deposlt Amount', value: data.refundabledeposit, span: 6 },
        { span: 5 },
        { label: 'Non-Refundable Fee Amount', value: data.nonrefundablefee, span: 6 },
        { label: 'Currency', value: data.currency, span: 6 },
        { label: 'Charge Unit', value: data.chargeunit, span: 6 },
        { span: 5 },
        { label: 'Restrictions Apply', value: data.restrictionsapply === 'true' ? 'Yes' : (data.restrictionsapply === 'false' ? 'No' : ''), span: 6 },
        { label: 'Service/Guide Dogs Allowed', value: data.servicedogsallowed === 'true' ? 'Yes' : (data.servicedogsallowed === 'false' ? 'No' : ''), span: 6 },
    ]

    return (
        <Tabs defaultActiveKey="detail">
            <TabPane tab="Detail" key="detail">
                <PageContainer>
                    <Card style={{ marginTop: -15 }} >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ fontWeight: 'bold' }}>{props?.petsDetails?.name ? props?.petsDetails?.name : ''}</div>
                            
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <div style={{margin: '0 10px 0 0'}}>
                                    <Button className="db-edit-btn" onClick={() => { props.changeTab('Pets') }}>Back</Button>
                                </div>
                                <div>
                                    <Button type="primary" className="db-edit-btn" onClick={toggleToEdit}>Edit</Button>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: "0 16px" }}>

                            <Row gutter={24}>
                                {detailData.map((item, i) => {
                                    return (
                                        <>
                                            {
                                                item.label ? <Col span={item.span} key={i} className="col-margin">
                                                    <DetailItem value={item.value} label={item.label} />
                                                </Col> : <Col span={item.span} key={i}></Col>
                                            }
                                        </>

                                    )
                                })
                                }
                            </Row>
                            <Row gutter={24}>
                                <Col span={18}>
                                    <ReadOnlyTextarea value={props?.petsDetails?.description} label="Description" />
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </PageContainer>
            </TabPane>
        </Tabs>

    )
}

export default PetsDetail;

